import * as createjs from 'createjs-module';
import { CjBitmap } from './cj-bitmap';
import { CjContainer } from './cj-container';
import iconArrowFrame from '../../../assets/img/icon/arrow_frame_layout.svg';
import iconRotateFrame from '../../../assets/img/icon/rotate_frame_layout.svg';
import iconArrowFreeSize from '../../../assets/img/icon/arrow_free_size.svg';
type CornerPosition = 'rt' | 'rb' | 'lb' | 'lt';
export type SidePosition = 't' | 'r' | 'b' | 'l';
export type IconPosition = CornerPosition | SidePosition | undefined;
export const CORNER_POSITIONS: CornerPosition[] = ['rt', 'rb', 'lb', 'lt'];
export const SIDE_POSITIONS: SidePosition[] = ['t', 'r', 'b', 'l'];
export const isSidePosition = (pos: IconPosition): pos is SidePosition => SIDE_POSITIONS.includes(pos as SidePosition);

export class CjFocusHandleIcon extends CjBitmap {
  readonly type: 'scale' | 'rotate';
  readonly position: IconPosition;
  readonly iconSize: number;
  static readonly maxIconSize = 28;
  private iconData: {
    x: number,
    y: number,
    rotation: number,
  };

  constructor(
    type: 'scale' | 'rotate',
    position: IconPosition,
    data: createjs.Rectangle,
  ) {
    if (type === 'scale') {
      if (isSidePosition(position)) {
        super(iconArrowFreeSize);
      } else {
        super(iconArrowFrame);
      }
      this.iconSize = 24;
    } else {
      super(iconRotateFrame);
      this.iconSize = 28;
    }
    switch (position) {
      case 'rt':
        this.iconData = {
          x: data.x + data.width,
          y: data.y,
          rotation: 0,
        };
        break;
      case 'rb':
        this.iconData = {
          x: data.x + data.width,
          y: data.y + data.height,
          rotation: type === 'scale' ? 90 : 180,
        };
        break;
      case 'lb':
        this.iconData = {
          x: data.x,
          y: data.y + data.height,
          rotation: 180,
        };
        break;
      case 'lt':
        this.iconData = {
          x: data.x,
          y: data.y,
          rotation: type === 'scale' ? 270 : 0,
        };
        break;
      case 't':
        this.iconData = {
          x: data.x + data.width / 2,
          y: data.y,
          rotation: 270,
        };
        break;
      case 'r':
        this.iconData = {
          x: data.x + data.width,
          y: data.y + data.height / 2,
          rotation: 0,
        };
        break;
      case 'b':
        this.iconData = {
          x: data.x + data.width / 2,
          y: data.y + data.height,
          rotation: 90,
        };
        break;
      case 'l':
        this.iconData = {
          x: data.x,
          y: data.y + data.height / 2,
          rotation: 180,
        };
        break;
      default:
        this.iconData = {
          x: 0,
          y: 0,
          rotation: 0,
        };
        break;
    }
    super.set({
      x: this.iconData.x,
      y: this.iconData.y,
      rotation: this.iconData.rotation,
      regY: this.iconSize / 2,
      regX: this.iconSize / 2,
    });
    this.type = type;
    this.position = position;
  }

  // static async createCornerAsync(
  //   x: number,
  //   y: number,
  //   rotation: number,
  //   container: CjContainer,
  //   type: 'scale' | 'rotate',
  //   position: 'rt' | 'rb' | 'lb' | 'lt',
  // ): Promise<CjCorner> {
  //   // FIXME: iconSizeを固定値から変更する
  //   const iconSize: number = 12;
  //   return new Promise((resolve) => {
  //     const corner = new CjCorner(type, position);
  //     container.addChild(corner);
  //     corner.set({
  //       x,
  //       y,
  //       rotation,
  //       regY: iconSize,
  //       regX: iconSize,
  //     });
  //     resolve(corner);
  //   });
  // }
}